var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSummaryTotalDispatches(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71429 2.85714C5.71429 4.4351 4.4351 5.71429 2.85714 5.71429C1.27919 5.71429 0 4.4351 0 2.85714C0 1.27919 1.27919 0 2.85714 0C4.4351 0 5.71429 1.27919 5.71429 2.85714Z",
    fill: "#2F80ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.1429C20 18.7209 18.7209 20 17.1429 20C15.5649 20 14.2857 18.7209 14.2857 17.1429C14.2857 15.5649 15.5649 14.2857 17.1429 14.2857C18.7209 14.2857 20 15.5649 20 17.1429Z",
    fill: "#2F80ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 5C11.4286 3.81653 12.388 2.85714 13.5714 2.85714C14.7549 2.85714 15.7143 3.81653 15.7143 5V11.4286H18.5714V5C18.5714 2.23857 16.3329 0 13.5714 0C10.81 0 8.57143 2.23857 8.57143 5V15C8.57143 16.1834 7.61204 17.1429 6.42857 17.1429C5.2451 17.1429 4.28571 16.1834 4.28571 15V8.57143H1.42857V15C1.42857 17.7614 3.66714 20 6.42857 20C9.19 20 11.4286 17.7614 11.4286 15V5Z",
    fill: "#2F80ED"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryTotalDispatches);
export default __webpack_public_path__ + "static/media/summary-total-dispatches.b113f404.svg";
export { ForwardRef as ReactComponent };